import React from "react";
import NavBar from "./NavBar";
import Coupons from "./Coupons";

function NewCoupon() {
  return (
    <div>
      <div>{/* <NavBar /> */}</div>
      <div>
        <div>
          <Coupons />
        </div>
      </div>
    </div>
  );
}

export default NewCoupon;
